import {FileText, Pencil} from "lucide-react";
import {FileItem} from "../../../components/FileItem.tsx";
import React, {useState} from "react";
import SamButton from "../../../components/SamButton.tsx";
import Modal from "../../../components/Modal.tsx";
import {AddFileNoteForm} from "../../../components/AddFileNoteForm.tsx";
import {FullFile, UserType} from "../../../api/ApiTypes.ts";

interface FilesTabProps {
    orderId?: number,
    files?: FullFile[],
    userType?: UserType
}
export const FilesTab: React.FC<FilesTabProps> = ({ files, orderId, userType }) => {

    const [ isAddFileNoteModalOpen, setIsAddFileNoteModalOpen ] = useState<boolean>(false);

    if (!orderId) {
        return (
            <div className="bg-white rounded-lg p-6 text-center border border-slate-200">
                <p className="text-slate-500">Order ID is not available.</p>
            </div>
        )
    }

    // Handle case when no files exist or array is empty
    if (!files || files.length === 0) {
        return (
            <div className="bg-white rounded-lg p-6 text-center border border-slate-200">
                <FileText className="h-10 w-10 text-slate-400 mx-auto mb-2" />
                <p className="text-slate-500">No files have been uploaded for this order.</p>
            </div>
        );
    }

    // Filter out hidden files and sort by upload date (newest first)
    const visibleFiles = files
        .filter(file => !file.hide)
        .sort((a, b) =>
            new Date(b.uploadDateTime).getTime() - new Date(a.uploadDateTime).getTime()
        );

    if (visibleFiles.length === 0) {
        return (
            <div className="bg-white rounded-lg p-6 text-center border border-slate-200">
                <FileText className="h-10 w-10 text-slate-400 mx-auto mb-2" />
                <p className="text-slate-500">No visible files are available for this order.</p>
            </div>
        );
    }

    const handleSuccess = () => {

        setIsAddFileNoteModalOpen(false);
    }

    const handleCancel = () => {

        setIsAddFileNoteModalOpen(false);
    }

    return (
        <div className="space-y-2">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-medium text-slate-800 mb-4">Order Files</h2>
                {userType && userType !== UserType.STAFF && (
                    <SamButton
                        className="flex items-center"
                        onClick={() => setIsAddFileNoteModalOpen(true)}
                    >
                        <Pencil className="h-4 w-4 mr-1" />
                        <span>Add note</span>
                    </SamButton>
                )}

            </div>

            {visibleFiles.map(file => (
                <FileItem key={file.id} file={file} />
            ))}

            <Modal isOpen={isAddFileNoteModalOpen}
                   onClose={()=> setIsAddFileNoteModalOpen(false)}
                   title={"Add Note"}
            >
                <AddFileNoteForm
                    orderId={orderId}
                    files={files}
                    onSuccess={handleSuccess}
                    onCancel={handleCancel}
                />
            </Modal>
        </div>
    );
};